export const FETCH_REDIRECT_NEEDED = 'FETCH_REDIRECT_NEEDED';
export const GET_PRACTICE_DETAILS = 'GET_PRACTICE_DETAILS';



// WEBPACK FOOTER //
// ./src/actions/public/types.js